// 登陆页
export const LOGIN_IN = 'LOGIN_IN';
// export const DISABLE_LOGIN = 'DISABLE_LOGIN';
// export const ABLE_LOGIN = 'ABLE_LOGIN';
// 注册页
export const DISABLE_SIGNUP = 'DISABLE_SIGNUP';
export const ABLE_SIGNUP = 'ABLE_SIGNUP';
export const GET_IMAGE_CODE = 'GET_IMAGE_CODE';
//首页
export const INVITECODE_STATUS_CODE = 'INVITECODE_STATUS_CODE'; //邀请码可领取状态
export const GET_NON_MAINLAND_LIST = 'GET_NON_MAINLAND_LIST'; //邀请码NON_MAINLAND可领取列表
export const GET_MAINLAND_LIST = 'GET_MAINLAND_LIST'; //邀请码MAINLAND可领取列表
export const GET_CALCULATE_LIST = 'GET_CALCULATE_LIST'; //邀请码calculate可领取列表	
export const GET_USER_INFO = 'GET_USER_INFO'; //邀请码可领取状态
// 硬件
export const GET_HARDLIST = 'GET_HARDLIST'; //获取硬件列表
export const GET_SEARCH_LIST = 'GET_SEARCH_LIST'; //获取硬件列表
// 收益
// export const INVITE_REVENUE_LIST = 'INVITE_REVENUE_LIST'; 
// export const GET_LASTDAY_INVITE = 'GET_LASTDAY_INVITE';
// export const ACCOUNT_LASTDAY_REVENUE = 'ACCOUNT_LASTDAY_REVENUE';
export const GET_RENVUE_DETAIL = 'GET_RENVUE_DETAIL';
export const GET_INVITE_DETAIL = 'GET_INVITE_DETAIL';
export const GET_NETWORK_CONTRIBUTION = 'GET_NETWORK_CONTRIBUTION';  //获取全网全100收益
// export const ACCOUNT_REVENUE_LIST = 'ACCOUNT_REVENUE_LIST'; 
export const GET_ALL_RENVUE = 'GET_ALL_RENVUE';
// 邀请
export const GET_RECOMMEND_INFO = 'GET_RECOMMEND_INFO';  //获取邀请链接
export const GET_RECOMMEND_COUNT = 'GET_RECOMMEND_COUNT';  //获取邀请人数
// 地址绑定
export const GET_WALLET_ADDRESS = 'GET_WALLET_ADDRESS';  //绑定eth地址
export const GET_WALLET_STATUS = 'GET_WALLET_STATUS';  //获取地址验证状态
// 提现
export const GET_WITHDRAWAL_LIST = 'GET_WITHDRAWAL_LIST';  //绑定eth地址
export const GET_BALANCE = 'GET_BALANCE';  //绑定eth地址
export const GET_WITHDRAWAL_STAUTS = 'GET_WITHDRAWAL_STAUTS';  //eth提现状态
export const GET_DEVICE_OVERVIEW = 'GET_DEVICE_OVERVIEW';  //设备总览
export const SET_FILTER_TYPE = 'SET_FILTER_TYPE';
export const SET_LAST_SEVEN_PRICE = 'SET_LAST_SEVEN_PRICE';
export const BUYBACK_LIST = 'BUYBACK_LIST'; //获取回购列表
export const BUYBACK_AUTH = 'BUYBACK_AUTH'; //获取回购权限
// wechat
export const GET_WECHAT_INFO = 'GET_WECHAT_INFO'; //获取微信用户信息
export const GET_WECHAT_BANLANCE = 'GET_WECHAT_BANLANCE';//获取BP余额
export const GET_WECHAT_SEVENDAYPRICE = 'GET_WECHAT_SEVENDAYPRICE';//获取 discount\RMBPrice\minAmount\maxAmount等信息

// 拨号配置
export const GET_DIAL_CONFIG = 'GET_DIAL_CONFIG';
export const GET_Node_CONFIG = 'GET_Node_CONFIG';

// 兑换
export const GET_EXCHANGE_INFO = 'GET_EXCHANGE_INFO';
export const GET_EXCHANGE_LIST = 'GET_EXCHANGE_LIST';
// 拨号状态
export const GET_DIAL_STATUS = 'GET_DIAL_STATUS';

export const GET_COUNTRY_INFO = 'GET_COUNTRY_INFO';








export const GET_BUSINESS = 'GET_BUSINESS'; //获取业务方

